import React from 'react';
import { Heading } from '@ui/primitives/Heading';
import { Text } from '@ui/primitives/Text';
import { cn } from '@ui/lib/utils';

interface HeaderProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    icon?: React.ReactNode;
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    align?: 'left' | 'center' | 'right';
    className?: string;
    iconClassName?: string;
}

export function Header({
    title,
    description,
    icon,
    as = 'h2',
    size = 'md',
    align = 'left',
    className,
    iconClassName
}: HeaderProps) {
    return (
        <div className={cn(
            "mb-4",
            align === 'center' && "text-center",
            align === 'right' && "text-right",
            align === 'left' && "flex items-center gap-3",
            className
        )}>

            <div className={cn(align === 'left' && "flex-1")}>
                <Heading as={as} size={size} className={cn("font-bold", description && "mb-1")}>
                    {icon} {title}
                </Heading>
                {description && (
                    <Text size="md" className="text-gray-500">
                        {description}
                    </Text>
                )}
            </div>
        </div>
    );
}
